import { BrainFunctionVisualisation } from 'lib/utils/business/brainfunction-categories/types';

export const imageStoreKeyFactory = {
  brainfunctionVisualisation: (brainfunction: BrainFunctionVisualisation) =>
    ['brainfunction', brainfunction.label].join('-')
};
